export default __webpack_public_path__ + "static/media/rnr-sports-table-9-cn.681c4045.webp";